import React from "react";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  StyledImageGrid,
  ConcludeContainer,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function QualifyAR() {
  const ProjectBG = require("../../../../assets/videos/qualify-ar/Poster_QualifyAR.png");
  const Grid1 = require("../../../../assets/videos/qualify-ar/1_QualifyAR.png");
  const T1 = require("../../../../assets/videos/qualify-ar/t1.png");

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="Qualify AR: augmented reality redefining education"
      lead={
        <p>
          Technical professions in aviation are becoming more complex, which
          calls for new ways to train and assess learners. Augmented reality
          supports users with contextual information for learning success and
          quality tests—so instructors can scale feedback beyond selective
          in-person reviews.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <StyledImageGrid src={Grid1} alt="" />
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Phase 1: BIBA WFE</WorkSectionHeading>
          <p>
            The Workflow Editor (WFE) is a desktop application that empowers
            teachers to create dynamic, interactive projects with multiple
            steps, presets, and 3D references. Teachers rearrange stages,
            publish projects, and make them available to students.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <video controls poster={T1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/argo-hytos/2_QualifyAR.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Phase 2: Qualify AR HoloLens</WorkSectionHeading>
          <p>
            Students use HoloLens 2 to open assigned projects, follow steps with
            descriptions and requirements, align digital models via QR codes,
            and run inspections—capturing images for server-side analysis and
            prompt feedback.
          </p>
          <WorkSectionHeading>
            Phase 3: Lernplatform for collaboration
          </WorkSectionHeading>
          <p>
            A desktop hub for teacher–student collaboration: teachers evaluate
            HoloLens data, students review feedback, and both track progress in
            one place.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <ConcludeContainer>
        <p>
          BIBA Qualify AR uses a centralized database for real-time sync across
          apps. It is a research project; applications are not publicly
          available.
        </p>
        <p style={{ marginTop: "1rem" }}>
          <a
            href="https://www.biba.uni-bremen.de/dbm/pdf/projects/qualifyar_ger.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            QualifyAR_Ger.pdf
          </a>
        </p>
      </ConcludeContainer>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "Qualify AR" },
          { label: "Period", value: "09.2022 - 01.2023" },
          { label: "Client", value: "BIBA" },
          { label: "Engine & Tools", value: "Unity, C#" },
          { label: "Platform", value: "PC, Hololens" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "AR, Desktop" },
        ]}
      />
    </WorkProjectShell>
  );
}
